<ng-container [formGroup]="parent">
  <ng-container formGroupName="packagingDetail">
    <h2 class="pt-3 pb-2">Packaging Details</h2>
    <div class="col-12">
      <div class="gray-bg-rounded">
        <div class="row">
          <div class="col-4">
            <h2 class="mb-2">Packaging</h2>
            <div class="row">
              <div class="col">
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="packageType"
                    >Packaging Type</label
                  >
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    name="PackagingType"
                    formControlName="packageType" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group has-float-label mb-2">
              <label class="form-label" for="packageCount"
                >Packaging Count</label
              >
              <input
                pInputText
                jniAutoCompleteBlocker
                type="email"
                name="PackagingCount"
                class="form-control"
                formControlName="packageCount" />
            </div>
            <div class="form-group has-float-label mb-2">
              <label class="form-label" for="weight">Weight</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                name="Weight"
                class="form-control"
                formControlName="weight" />
            </div>
          </div>
          <div class="col-2">
            <div class="form-group has-float-label mb-2">
              <label class="form-label" for="weightUOM">WeightUOM</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="email"
                name="WeightUOM"
                class="form-control"
                formControlName="weightUOM" />
            </div>
            <div class="form-group has-float-label mb-2">
              <label class="form-label" for="Length">length</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                name="Length"
                class="form-control"
                formControlName="length" />
            </div>
          </div>
          <div class="col-2">
            <div class="form-group has-float-label mb-2">
              <label class="form-label" for="width">Weight</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="email"
                name="Weight"
                class="form-control"
                formControlName="width" />
            </div>
            <div class="form-group has-float-label mb-2">
              <label class="form-label" for="Height">Height</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                name="Height"
                class="form-control"
                formControlName="height" />
            </div>
          </div>
          <div class="col-2">
            <div class="form-group has-float-label mb-2">
              <label class="form-label" for="dimensionUOM"
                >DimensionalUOM</label
              >
              <input
                pInputText
                jniAutoCompleteBlocker
                type="email"
                name="DimensionalUOM"
                class="form-control"
                formControlName="dimensionUOM" />
            </div>
            <div class="form-group has-float-label mb-2">
              <label class="form-label" for="DimensionalWeight"
                >DimensionalWeight</label
              >
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                name="DimensionalWeight"
                class="form-control"
                formControlName="dimesionWeight" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
